import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/interface-lock-open-unlock.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M208 80H96V56a32 32 0 0 1 32-32c15.37 0 29.2 11 32.16 25.59a8 8 0 0 0 15.68-3.18C171.32 24.15 151.2 8 128 8a48.05 48.05 0 0 0-48 48v24H48a16 16 0 0 0-16 16v112a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16m0 128H48V96h160zm-68-56a12 12 0 1 1-12-12 12 12 0 0 1 12 12" }, null, -1)])]);
}
var interface_lock_open_unlock_default = { render };
//#endregion
export { interface_lock_open_unlock_default as default, render };

//# sourceMappingURL=interface-lock-open-unlock.svg.js.map